import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Components/Sidebar/Sidebar";
import { useDispatch } from "react-redux";
// import AuthNavbar from "../Components/AuthNavbar/AuthNavbar";
// import { fetchNotifications } from "../hooks/Notifications";
// import { fetchStudents } from "../hooks/Students";
// import { fetchGrades } from "../hooks/Grades";
// import { fetchStages } from "../hooks/Stages";
// import { fetchClasss } from "../hooks/Classes";
// import { fetchSubjects } from "../hooks/Subjects";
// import { fetchTeachers } from "../hooks/Teacher";
// import { fetchEmployee } from "../hooks/Employee";

function Layout() {
  const dispatch = useDispatch()
  // useEffect(() => {
  //   dispatch(fetchNotifications())
  //   dispatch(fetchStudents())
  //   dispatch(fetchGrades())
  //   dispatch(fetchStages())
  //   dispatch(fetchClasss())
  //   dispatch(fetchSubjects())
  //   dispatch(fetchTeachers())
  //   dispatch(fetchEmployee())
  // }, [dispatch])

  return (

    <div style={{ display: "flex", height: "100vh" }}>

      <div className="normalQuery">
        <Sidebar />
      </div>
      <div style={{ flex: 1, height: "100vh", overflowY: "scroll" }}>
        {/* <AuthNavbar /> */}

        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
